var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appeal-review-fullscreen"},[(_vm.batchId)?_c('AppealReview',{attrs:{"batch-id":_vm.batchId,"initial-record-id":_vm.initialRecordId},on:{"back":_vm.handleBack}}):_c('div',{staticClass:"loading-tip"},[_c('p',[_vm._v("参数错误，请返回")]),_c('el-button',{on:{"click":_vm.handleBack}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }